export const SET_CONCEDENTES_CONTATOS =
  "CONCEDENTES_CONTATOS/SET_CONCEDENTES_CONTATOS";
export const SET_CONCEDENTE_CONTATO =
  "CONCEDENTES_CONTATOS/SET_CONCEDENTE_CONTATO";
export const SET_PAGINATION = "CONCEDENTES_CONTATOS/SET_PAGINATION";
export const SET_ISLOADING = "CONCEDENTES_CONTATOS/SET_ISLOADING";
